<template>
  <div class="maintain-manage-bd tb">
    <custom-tab :list="tabData" v-model="tabIndex" @changeBefore="onChangeTab"></custom-tab>
    <div class="tab-content">
      <rework v-if="tabIndex === 2" :form="formSearch" ref="tab2"></rework>
      <repair v-if="tabIndex === 1" :form="formSearch" ref="tab1"></repair>
      <maintain v-if="tabIndex === 0" :form="formSearch" ref="tab0"></maintain>
    </div>
  </div>
</template>

<script>
import maintain from './children/maintain';
import repair from './children/repair';
import rework from './children/rework';

export default {
  components: { maintain, repair, rework },
  name: 'maintain_manage',
  data() {
    return {
      formSearch: {
        productCode: '',
        search: '',
      },
      tabIndex: 1,
      tableList: [],
      totalRows: null,
    };
  },
  computed: {
    tabData() {
      return [
        {
          name: this.$t('asm_maintain_manage.wei_xiu'),
          value: 1,
        },
        {
          name: this.$t('asm_maintain_manage.bao_yang'),
          value: 0,
        },
        {
          name: this.$t('asm_maintain_manage.fan_gong'),
          value: 2,
        },
      ];
    },
  },
  mounted: function () {
  },
  methods: {
    onChangeTab(idx) {
      this.formSearch = this.$refs[`tab${idx}`].formSearch;
    },
  },
};
</script>

<style lang="scss" scoped>
.maintain-manage-bd {
  padding: 0 !important;
  display: flex;
  flex-direction: column;

  .tab-content {
    flex: 1;
  }
}
</style>
